import React from "react";
import { useNavigate } from 'react-router-dom';
import './Contact.css';

const Contact = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = React.useState({
        company: '',
        name: '',
        email: '',
        phone: '',
        message: '',
        plan: 'free'
    });

    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [submitError,  setSubmitError]  = React.useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitError('');

        try {
            const res = await fetch('/api/contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const text = await res.text();
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (_) {
                const statusMsg = res.status === 404
                    ? 'APIファイルが見つかりません（404）。サーバーへのアップロードをご確認ください。'
                    : `サーバーエラーが発生しました（HTTP ${res.status}）。`;
                setSubmitError(statusMsg);
                console.error('[contact] non-JSON response:', text.substring(0, 300));
                return;
            }

            if (res.ok && json && json.success) {
                // ── Google広告 コンバージョン発火（送信成功時のみ）──
                if (typeof window.gtag === 'function') {
                    window.gtag('event', 'conversion', {
                        send_to: 'AW-18008466606/nGMfCJz-qokcEK7JjYtD',
                        event_callback: () => {
                            navigate('/thanks', {
                                state: {
                                    plan: formData.plan,
                                    name: formData.name,
                                }
                            });
                        }
                    });
                    // gtag が応答しない場合の保険（2秒後に強制遷移）
                    setTimeout(() => {
                        navigate('/thanks', {
                            state: {
                                plan: formData.plan,
                                name: formData.name,
                            }
                        });
                    }, 2000);
                } else {
                    // gtag が読み込まれていない環境では直接遷移
                    navigate('/thanks', {
                        state: {
                            plan: formData.plan,
                            name: formData.name,
                        }
                    });
                }
            } else {
                setSubmitError(
                    json?.error
                        ? `送信エラー: ${json.error}`
                        : '送信に失敗しました。しばらく経ってから再度お試しいただくか、お電話にてご連絡ください。'
                );
            }
        } catch (err) {
            setSubmitError('通信エラーが発生しました。インターネット接続をご確認のうえ、再度お試しください。');
            console.error('[contact] fetch error:', err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className="contact" id="contact">
            <div className="contact-container">
                <div className="contact-info">
                    <h2 className="section-title">お問い合わせ</h2>
                    <p className="section-subtitle">
                        無料相談受付中<br />
                        お気軽にご相談ください
                    </p>
                    
                    <div className="info-items">
                        <div className="info-item">
                            <div className="info-icon"></div>
                            <div className="info-content">
                                <div className="info-label">電話でのお問い合わせ</div>
                                <div className="info-value">090-2377-3553</div>
                                <div className="info-note">平日 9:00-18:00</div>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon"></div>
                            <div className="info-content">
                                <div className="info-label">メールでのお問い合わせ</div>
                                <div className="info-value">moribekazutaka@gmail.com</div>
                                <div className="info-note">24時間受付</div>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon"></div>
                            <div className="info-content">
                                <div className="info-label">所在地</div>
                                <div className="info-value">石川県金沢市畝田東</div>
                                <div className="info-note"></div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="contact-form-wrapper">
                    <form className="contact-form" onSubmit={handleSubmit}>

                        {/* ─── プラン選択ラジオボタン ─── */}
                        <div className="form-group plan-select-group">
                            <label className="plan-select-label">
                                ご希望のプランをお選びください <span className="required">*</span>
                            </label>
                            <div className="plan-radio-cards">
                                <label
                                    className={`plan-radio-card plan-radio-free${formData.plan === 'free' ? ' selected' : ''}`}
                                    htmlFor="plan-free"
                                >
                                    <input
                                        type="radio"
                                        id="plan-free"
                                        name="plan"
                                        value="free"
                                        checked={formData.plan === 'free'}
                                        onChange={handleChange}
                                    />
                                    <span className="plan-radio-check"></span>
                                    <span className="plan-card-badge plan-badge-free">期間限定</span>
                                    <span className="plan-card-price">¥<strong>0</strong></span>
                                    <span className="plan-card-name">お試しプラン</span>
                                    <span className="plan-card-desc">まず無料で試したい方へ</span>
                                </label>

                                <label
                                    className={`plan-radio-card plan-radio-standard${formData.plan === 'standard' ? ' selected' : ''}`}
                                    htmlFor="plan-standard"
                                >
                                    <input
                                        type="radio"
                                        id="plan-standard"
                                        name="plan"
                                        value="standard"
                                        checked={formData.plan === 'standard'}
                                        onChange={handleChange}
                                    />
                                    <span className="plan-radio-check"></span>
                                    <span className="plan-card-badge plan-badge-standard">スタンダード</span>
                                    <span className="plan-card-price">¥<strong>55,000</strong><small>〜/月</small></span>
                                    <span className="plan-card-name">通常プラン</span>
                                    <span className="plan-card-desc">本格的な広告運用を始めたい方へ</span>
                                </label>
                            </div>
                        </div>

                        {/* ─── 既存フィールド ─── */}
                        <div className="form-group">
                            <label htmlFor="company">会社名</label>
                            <input
                                type="text"
                                id="company"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                placeholder="株式会社〇〇"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="name">お名前 <span className="required">*</span></label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="山田 太郎"
                                required
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="email">メールアドレス <span className="required">*</span></label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="example@example.com"
                                required
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="phone">電話番号</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="090-1234-5678"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="message">お問い合わせ内容 <span className="required">*</span></label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="ご質問やご相談内容をご記入ください"
                                rows="6"
                                required
                            ></textarea>
                        </div>

                        {/* ─── エラーメッセージ ─── */}
                        {submitError && (
                            <div className="submit-error" role="alert">
                                <span>⚠️</span> {submitError}
                            </div>
                        )}
                        
                        <button
                            type="submit"
                            className="submit-btn"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? '送信中…' : '送信する'}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Contact;